import React from 'react';

import Icon from '../../Icons';
import { getDateFromTimeInSec, parsePrice } from '../../../utils/utils';
import VehicleRecharge from './AutoRecharge';
import VehicleTag from './Tag';
import { tagColor } from './Tag';
import Redirect from '../../Redirect';
import Recharge from '../Recharge/Recharge';
interface Props {
  vehicleNumber: string;
}

const Highlighter = (props: any) => <span className={`highlighter ${tagColor[props.tagClass]}`} />;

const VehicleNo = (props: any) => (
  <div className="column">
    <p>{props.vehicleNumber}</p>
  </div>
);

const VehicleToll = (props: any) => (
  <div className="column">
    <p>{props.lastTollName || '---'}</p>
    <p className="date mt8">{getDateFromTimeInSec(props.lastTollTime)}</p>
  </div>
);

const VehicleBal = (props: any) => (
  <div className="column">
    <p>{parsePrice({ price: props.fastagAmount })}</p>
  </div>
);

const VehicleAction = (props: any) => (
  <div className="column">
    <Recharge tagId={props.tagId} amount={props.fastagAmount} vehicle={props.vehicleNumber} />
    <span className="margl16">
      <Icon name="arrow" />
    </span>
  </div>
);

const Overlay = (props: any) => (
  <div className="data-row-overlay t0 l0 absolute wfull hfull">
    <Redirect
      url={`/portal/fastag/details`}
      state={{ vehicleNumber: props.vehicleNumber, autoRecharge: props.autoRecharge }}
    />
  </div>
);

interface headingObj {
  heading: string;
}

export interface ComponentList {
  name: string;
  attr?: Array<string>;
  heading: string;
}

export const dataMapping = (headingProps: headingObj) => [
  {
    name: VehicleNo,
    attr: ['vehicleNumber'],
    heading: headingProps.heading,
  },
  {
    name: VehicleTag,
    attr: ['tagClass', 'fastagColor'],
    heading: 'Tag Class',
  },
  {
    name: VehicleToll,
    attr: ['lastTollName', 'lastTollTime'],
    heading: 'Last Toll',
  },
  {
    name: VehicleBal,
    attr: ['fastagAmount'],
    heading: 'Balance',
  },
  {
    name: VehicleRecharge,
    attr: ['autoRecharge', 'minBalance', 'tagId', 'vehicleNumber'],
    heading: 'Auto Recharge',
  },
  {
    name: VehicleAction,
    attr: ['tagId', 'vehicleNumber', 'fastagAmount'],
    heading: 'Action',
  },
  {
    name: Highlighter,
    attr: ['tagClass'],
  },
  {
    name: Overlay,
    attr: ['vehicleNumber', 'autoRecharge'],
  },
];

export { VehicleTag };
